import type { ReactNode } from 'react'
import type { StatusTone } from '@/ui/Status/Status'
import { cx } from '../cx'
import { Icon } from '../Icon/Icon'
import type { IconName } from '../Icon/icons'
import styles from './Alert.module.css'

export type AlertTone = Exclude<StatusTone, 'neutral'>

const GLYPH: Record<AlertTone, IconName> = {
  danger: 'cross-circled',
  warning: 'exclamation-triangle',
  success: 'check-circled',
  info: 'info-circled',
}

export function Alert({
  tone,
  icon = true,
  className,
  children,
}: {
  tone: AlertTone
  icon?: boolean
  className?: string
  children: ReactNode
}) {
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cx(styles.alert, className)}
      data-tone={tone}
    >
      {icon && <Icon name={GLYPH[tone]} size="icon-inline" />}
      <div className={styles.message}>{children}</div>
    </div>
  )
}
